import { Spinner } from '@shared/components/ui/Spinner';

export const LoadingState = () => (
  <div className="flex flex-col items-center justify-center w-full min-h-[calc(100vh-150px)]">
    <Spinner size="md" />
  </div>
);
